<div *ngIf="cargando">
  <div class="text-center py-5">
    <mat-spinner class="img-center"></mat-spinner>
  </div>
  <div class="text-center py-5">
    <span>Cargando datos...</span>
  </div>
</div>

<div class="mx-auto row mt-2 mb-4" *ngIf="!cargando">
  <div class="col-md-6">
    <div class="row g-2 text-start">
      <div *ngIf="esDebugger" [class.col-2]="esDebugger">
        <label for="id" class="form-label mb-0">ID</label>
        <input type="text" class="form-control bg-light" id="rfc" [value]="empleado.id" onClick="this.select();" readonly>
      </div>
      <div class="col-2" [class.col-3]="!esDebugger">
        <label for="rfc" class="form-label mb-0">Clave</label>
        <input type="text" class="form-control bg-light" id="rfc" [(ngModel)]="empleado.numero" onClick="this.select();" [readOnly]="!isModificando || estaGuardando" [ngClass]="{ 'bg-white': isModificando }">
      </div>
      <div class="col-8" [class.col-9]="!esDebugger" *ngIf="!isModificando">
        <label for="nombre" class="form-label mb-0">Nombre</label>
        <input type="text" class="form-control bg-light" [ngClass]="{'text-uppercase': aplicarUpperCase}" id="nombre" [value]="nombreCompleto()" onClick="this.select();" readonly>
      </div>
      <div class="col-8" [class.col-9]="!esDebugger" *ngIf="isModificando">
        <label for="nombre" class="form-label mb-0">Nombre(s)</label>
        <input type="text" class="form-control bg-light" id="nombre" [(ngModel)]="empleado.nombre" onClick="this.select();" [readOnly]="!isModificando || estaGuardando" [ngClass]="{ 'bg-white': isModificando || esNuevoEmpleado, 'text-uppercase': aplicarUpperCase }">
      </div>
      <div class="col-md-6" *ngIf="isModificando">
        <label for="apellidoPaterno" class="form-label mb-0">Apellido Paterno</label>
        <input type="text" class="form-control bg-light" id="apellidoPaterno" [(ngModel)]="empleado.paterno" onClick="this.select();" [readOnly]="!isModificando || estaGuardando" [ngClass]="{ 'bg-white': isModificando || esNuevoEmpleado, 'text-uppercase': aplicarUpperCase }">
      </div>
      <div class="col-md-6" *ngIf="isModificando">
        <label for="apellidoMaterno" class="form-label mb-0">Apellido Materno</label>
        <input type="text" class="form-control bg-light" id="apellidoMaterno" [(ngModel)]="empleado.materno" onClick="this.select();" [readOnly]="!isModificando || estaGuardando" [ngClass]="{ 'bg-white': isModificando || esNuevoEmpleado, 'text-uppercase': aplicarUpperCase }">
      </div>
      <div class="col-md-6">
        <label for="rfc" class="form-label mb-0">R.F.C.</label>
        <input type="text" class="form-control bg-light" id="rfc" [(ngModel)]="empleado.rfc" onClick="this.select();" [readOnly]="!isModificando || estaGuardando" [ngClass]="{ 'bg-white': isModificando || esNuevoEmpleado, 'text-uppercase': aplicarUpperCase }">
      </div>
      <div class="col-md-6">
        <label for="curp" class="form-label mb-0">CURP</label>
        <input type="text" class="form-control bg-light" id="curp" [(ngModel)]="empleado.curp" onClick="this.select();" [readOnly]="!isModificando || estaGuardando" [ngClass]="{ 'bg-white': isModificando || esNuevoEmpleado, 'text-uppercase': aplicarUpperCase }">
      </div>
      <div class="col-md-6">
        <label for="imss" class="form-label mb-0">IMSS</label>
        <input type="text" class="form-control bg-light" id="imss" [(ngModel)]="empleado.imss" onClick="this.select();" [readOnly]="!isModificando || estaGuardando" [ngClass]="{ 'bg-white': isModificando || esNuevoEmpleado, 'text-uppercase': aplicarUpperCase }">
      </div>
      <div class="col-md-6">
        <label for="correo" class="form-label mb-0">Correo</label>
        <input type="text" class="form-control bg-light" id="correo" [(ngModel)]="empleado.correo" onClick="this.select();" [readOnly]="!isModificando || estaGuardando" [ngClass]="{ 'bg-white': isModificando || esNuevoEmpleado, 'text-uppercase': aplicarUpperCase }">
      </div>
      <div class="col-md-6">
        <label class="mb-0 text-start">Área</label>
        <ng-select #ngSelect
                   [addTag]="true"
                   [items]="areasEmpleados"
                   [(ngModel)]="empleado.area"
                   notFoundText="Área no encontrada"
                   placeholder="Área"
                   appendTo="body"
                   dropdownPosition="auto"
                   [disabled]="!isModificando || estaGuardando"
                   [ngClass]="{ 'bg-white': isModificando || esNuevoEmpleado,'text-uppercase': aplicarUpperCase }"
                   (search)="nuevaArea = $event.term"
                   (blur)="verificarValor()">
        </ng-select>
      </div>
      <div class="col-md-6">
        <label for="puesto" class="form-label mb-0">Puesto</label>
        <input type="text" class="form-control bg-light" id="puesto" [(ngModel)]="empleado.puesto" onClick="this.select();" [readOnly]="!isModificando || estaGuardando" [ngClass]="{ 'bg-white': isModificando || esNuevoEmpleado, 'text-uppercase': aplicarUpperCase }">
      </div>
      <div class="col-md-6" *ngIf="!isModificando || !esNuevoEmpleado">
        <label for="alta" class="form-label mb-0">Fecha de alta</label>
        <input type="text" class="form-control bg-light" id="alta" [ngClass]="{'text-uppercase': aplicarUpperCase}" [value]="formatoFecha(empleado.alta)" onClick="this.select();" readonly>
      </div>
      <div class="col-12 col-xl-6" *ngIf="isModificando && esNuevoEmpleado">
        <label for="filtroEmpleado" class="form-label mb-0">Fecha de alta</label>
        <div class="position-relative">
          <!-- ========== input oculto ============ -->
          <input type="text" matInput [matDatepicker]="picker" [(ngModel)]="empleado.alta" class="d-none">
          <!-- ========== input visible ============ -->
          <input type="text" [value]="empleado.alta | formatoFecha" class="form-control" readonly (click)="picker.open()">
          <mat-icon fontIcon="calendar_month" class="position-absolute top-50 translate-middle-y end-0 me-3" style="cursor: pointer;" (click)="picker.open()"></mat-icon>
          <mat-datepicker touchUi #picker></mat-datepicker>
        </div>
      </div>
      <div class="col-md-6" *ngIf="tipoEmpleado >= TipoEmpleado.Administrador">
        <label for="baja" class="form-label mb-0">Fecha de baja</label>
        <input type="text" class="form-control bg-light" id="baja" [value]="formatoFecha(empleado.baja)" onClick="this.select();" readonly>
      </div>
      <div class="col-md-6" *ngIf="!esNuevoEmpleado">
        <label class="form-label mb-0" (click)="mostrarOpciones()">Tipo de empleado</label>
        <select class="form-select bg-light" aria-label="Default select example" [(ngModel)]="empleado.tipoEmpleado" [disabled]="!isModificando" [ngClass]="{ 'bg-white': isModificando || esNuevoEmpleado, 'text-uppercase': aplicarUpperCase }">
          <option *ngFor="let tEmpleado of tiposEmpleadoFiltrados" [value]="tEmpleado.key">
            {{ tEmpleado.value }}
          </option>
        </select>
      </div>
      <div class="col-md-6" *ngIf="!esNuevoEmpleado">
        <label class="form-label mb-0">Manejo de empleado</label>
        <select class="form-select bg-light" aria-label="Default select example" [(ngModel)]="empleado.manejoAccesoExpress" [disabled]="!isModificando" [ngClass]="{ 'bg-white': isModificando || esNuevoEmpleado, 'text-uppercase': aplicarUpperCase }">
          <option *ngFor="let mEmpleado of manejoEmpelado | keyvalue" [value]="mEmpleado.key">
            {{ mEmpleado.value }}
          </option>
        </select>
      </div>
      <div class="col-md-6">
        <label class="mb-0 text-start">{{etiquetaAgrupar}}</label>
        <ng-select #ngSelect
                   [addTag]="true"
                   [items]="grupoEmpleados"
                   [(ngModel)]="empleado.grupo"
                   notFoundText="Grupo no encontrada"
                   placeholder="Grupo"
                   appendTo="body"
                   dropdownPosition="auto"
                   [disabled]="!isModificando || estaGuardando"
                   [ngClass]="{ 'bg-white': isModificando || esNuevoEmpleado, 'text-uppercase': aplicarUpperCase }"
                   (search)="nuevoGrupo = $event.term"
                   (blur)="verificarValor()">
        </ng-select>
      </div>
      <div class="col-md-6">
        <label class="form-label mb-0">ID Referencia</label>
        <div class="input-group">
          <input type="text" class="form-control bg-light" [(ngModel)]="empleado.idReferencia" onClick="this.select();" [disabled]="!isModificando" [ngClass]="{ 'bg-white': isModificando || esNuevoEmpleado, 'text-uppercase': aplicarUpperCase }">
          <span class="input-group-text border-0">
            <mat-icon fontIcon="help" class="opacity-50" style="cursor: pointer;" title="Más información sobre este campo" (click)="abrirModal(infoTemplate)"></mat-icon>
          </span>
        </div>
      </div>
      <div class="col-md-6" *ngIf="esDebugger">
        <label for="ultimaCargaCF" class="form-label mb-0">Ultima Carga CF</label>
        <input type="text" class="form-control bg-light" id="ultimaCargaCF" [value]="formatoFecha(empleado.ultimaCargaCF)" onClick="this.select();" readonly>
      </div>
    </div>
  </div>
  <div class="col-md-6">
    <div class="row g-2">
      <div class="d-flex justify-content-end mb-2 gap-2 mt-4" *ngIf="!mostrarElementos">
        <button mat-raised-button class="text-primary-emphasis" (click)="controlVacacionesDialog()" *ngIf="!isModificando">
          Control de vacaciones
        </button>
        <button mat-raised-button class="text-primary-emphasis" (click)="validarIncidenciaDialog()" *ngIf="!isModificando">
          Validación de incidencias
        </button>
        <button mat-raised-button matTooltip="Editar datos" class="text-primary" (click)="modificarDatos()" *ngIf="!isModificando">
          <mat-icon class="me-0">edit</mat-icon>
        </button>
        <button mat-raised-button matTooltip="Dar de baja empleado" class="text-danger" (click)="abrirModal(baja)" *ngIf="!isModificando && !tieneBaja">
          <mat-icon class="me-0">person_remove</mat-icon>
        </button>
        <button mat-raised-button matTooltip="Re-ingreso" class="text-success" (click)="abrirModal(reingreso)" *ngIf="!isModificando && tieneBaja && esDebugger">
          <mat-icon class="me-0">autorenew</mat-icon>
        </button>
        <div *ngIf="isModificando" class="d-flex gap-2">
          <button mat-raised-button matTooltip="Guardar cambios" class="text-success" (click)="guardarDatos()">
            <mat-icon class="me-0">save</mat-icon>
          </button>
          <button mat-raised-button matTooltip="Deshacer" class="text-danger" (click)="deshacerDatos()">
            <mat-icon class="me-0">reply</mat-icon>
          </button>
        </div>
      </div>
      <div *ngIf="!esNuevoEmpleado" class="d-flex flex-column justify-content-center align-items-center" (click)="emitirMostrarReconocimientoFacial()" style="min-height: 380px;">
        <img *ngIf="!empleado.tieneDatosRF" src="assets/images/face.png" alt="..." class="opacity-50" style="width: 18rem;">
        <img *ngIf="empleado.tieneDatosRF" src="{{'data:image/jpg;base64,' + empleado.datosRF.datos}}" style="width: 18rem; object-fit: contain;"/>
        <div class="d-flex gap-2 mt-3">
          <button (click)="emitirMostrarReconocimientoFacial()" mat-raised-button class="text-primary-emphasis" matTooltip="Subir foto" [disabled]="isModificando">
            <mat-icon class="me-0">face</mat-icon>
          </button>
          <button (click)="emitirMostrarCodigo()" mat-raised-button class="text-primary" matTooltip="Codigo QR" [disabled]="isModificando">
            <mat-icon class="me-0">qr_code_scanner</mat-icon>
          </button>
          <button (click)="emitirMostrarRegistroIncidencias()" mat-raised-button class="text-primary" matTooltip="Mostrar registro de incidencias" [disabled]="isModificando">
            <mat-icon class="me-0">perm_media</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #reingreso>
  <div class="text-center">
    <div class="mx-auto mt-2">
      <h2 class="fw-medium mb-0">Seleccione la fecha de reingreso del empleado {{ nombreCompleto() }}</h2>
    </div>
  </div>
  <div class="modal-body pt-0">
    <div class="mt-3">
      <input type="date" class="form-control" [(ngModel)]="fechaReingreso">
    </div>
    <div class="pt-4">
      <div class="text-end">
        <button type="button" class="btn btn-danger mx-2" (click)="modalRef?.hide()">Cancelar</button>
        <button type="button" class="btn btn-success" (click)="guardarCambioContrato()">Guardar</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #baja>
  <div class="text-center">
    <div class="mx-auto mt-2">
      <h2 class="fw-medium mb-0">Seleccione la fecha con la que se dará de baja a el empleado {{ nombreCompleto() }}</h2>
    </div>
  </div>
  <div class="modal-body pt-0">
    <div class="mt-3">
      <input type="date" class="form-control" [(ngModel)]="fechaBaja">
    </div>
    <div class="pt-4">
      <div class="text-end">
        <button type="button" class="btn btn-danger mx-2" (click)="modalRef?.hide()">Cancelar</button>
        <button type="button" class="btn btn-success" (click)="bajaEmpleado()">Guardar</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #infoTemplate>
  <div class="modal-header border-0 p-2">
    <h4 class="modal-title fw-medium mb-0">Información</h4>
    <button type="button" class="btn-close" aria-label="Cerrar" (click)="modalRef?.hide()"></button>
  </div>
  <div class="modal-body">
    Este campo es para el ID de su programa de nómina.
    <br>
    <span class="text-danger">Si usted usa NomiExpress Web, no es necesario llenarlo.</span>
  </div>
</ng-template>
